import { BusinessType } from "../models/Enums";


export function initializePendo(pendoInfo) {
  debugger
  var apiKey = pendoInfo.pendoKey;
(function (p, e, n, d, o) {
  var v, w, x, y, z;
  if (o == undefined || o == null) {
      o = p[d] = p[d] || {}; o._q = o._q || [];
  }
  v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track']; for (w = 0, x = v.length; w < x; ++w)(function (m) {
      o[m] = o[m] || function () { o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0))); };
  })(v[w]);
  y = e.createElement(n); y.async = !0;
  y.src = 'https://cdn.pendo.io/agent/static/' + apiKey + '/pendo.js';
  z = e.getElementsByTagName(n)[0]; z.parentNode.insertBefore(y, z);
})(window, document, 'script', 'pendo');

// Call this whenever information about your visitors becomes available
// Please use Strings, Numbers, or Bools for value types.
debugger;
window.pendo.initialize({
  visitor: {
      id: pendoInfo.workstationCode + '_therapist_' + pendoInfo.loggedInUserId,  // Required if user is logged in
      // email:        // Recommended if using Pendo Feedback, or NPS Email
      // full_name: dataObj.User.FirstName + dataObj.User.LastName,    // Recommended if using Pendo Feedback
      role: 'therapist',    // Optional
      //role: pendoInfo.User.UserType,
      email: pendoInfo.email,
      first_name: pendoInfo.firstName,
      last_name: pendoInfo.lastName,
      direct_connect: pendoInfo.businessType == 2 ? true : false, // 2 is for direct connect
      language: 'English',
      software_version: localStorage.getItem("mobileUiVersion"),
      // You can add any additional visitor level key-values here,
      // as long as it's not one of the above reserved names.
  },

  account: {
      id: pendoInfo.businessCode, // Highly recommended
      business_name: pendoInfo.businessName,
      location_name: pendoInfo.locationName
      // name:         // Optional
      // is_paying:    // Recommended if using Pendo Feedback
      // monthly_value:// Recommended if using Pendo Feedback
      // planLevel:    // Optional
      // planPrice:    // Optional
      // creationDate: // Optional

      // You can add any additional account level key-values here,
      // as long as it's not one of the above reserved names.
  }
});
}